import {Loadable} from 'recoil';
import {IPageableDto} from '../types/pageable.types';
import {ToastOptions} from 'react-toastify';

export class LoadableHelpers {
  static hasValue<T = unknown>(loadable: Loadable<T>): boolean {
    return loadable.state === 'hasValue';
  }
  static isLoading<T = unknown>(loadable: Loadable<T>): boolean {
    return loadable.state === 'loading';
  }

  static isError<T = unknown>(loadable: Loadable<T>): boolean {
    return loadable.state === 'hasError';
  }

  static withDefault<T = unknown>(loadable: Loadable<T>, defaultValue: T): T {
    return this.isError(loadable) || this.isLoading(loadable) ? defaultValue : loadable.contents;
  }

  static withDefaultPageable<T = unknown>(loadable: Loadable<IPageableDto<T>>, defaultValue: T[]): T[] {
    return this.isError(loadable) || this.isLoading(loadable) ? defaultValue : loadable.contents.content;
  }

  static handle<T = unknown>(
    loadable: Loadable<T>,
    handlers: {
      error?: (key: string, args: [unknown, ToastOptions]) => void;
      success?: (content: T) => void;
      loading?: () => void;
    },
    key?: string,
  ): void {
    if (this.hasValue(loadable)) {
      handlers?.success?.(loadable.contents);
    }

    if (this.isError(loadable)) {
      handlers?.error?.('error', [loadable.contents, {toastId: key}]);
    }

    if (this.isLoading(loadable)) {
      handlers?.loading?.();
    }
  }
}
